import styled from '@emotion/styled';

export const Container = styled.div`
    padding: 0;
`;

export const HeaderSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 32px;
    gap: 24px;
`;

export const Title = styled.h2`
    font-size: 24px;
    font-weight: 600;
    color: #111827;
    margin: 0 0 8px 0;
`;

export const Description = styled.p`
    color: #6b7280;
    font-size: 14px;
    margin: 0;
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 12px;
`;

export const SettingsButton = styled.button`
    background: white;
    color: #6366f1;
    border: 1px solid #6366f1;
    border-radius: 8px;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 6px;

    &:hover {
        background: #f5f3ff;
        border-color: #5558e3;
        color: #5558e3;
    }

    &:active {
        background: #ede9fe;
    }
`;

export const ManageBillingButton = styled.button`
    background: #7c3aed;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.2s ease;

    &:hover {
        background: #6d28d9;
    }

    &:active {
        background: #5b21b6;
    }

    &:disabled {
        background: #d1d5db;
        cursor: not-allowed;
    }
`;
